

































































import { Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Role, UserType } from '@/api/types'
import ToggleInactiveUsersButton from '@/views/Company/Settings/Users/List/ToggleInactiveUsersButton.vue'
import ListUsers from '@/views/Company/Settings/Users/List/ListUsers.vue'
import { UserAPI } from '@/api/backend-client'

@Component({
    components: { ToggleInactiveUsersButton, ListUsers },
})
export default class CompanySettingsUsersList extends Vue {

    loading = true
    users: User[] = []
    showInactiveUsers: boolean = false

    async mounted() {
        this.users = await UserAPI.getAll({ company: this.$currentCompany.id })
        this.loading = false
    }

    async navigateToCreateFromRealworks(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_users_create_from_realworks',
        })
    }

    async navigateToCreate(): Promise<void> {
            await this.$router.push({
                name: 'company_settings_users_create',
            })
    }

    get canCreateUser(): boolean {
        if (this.loading) {
            return false
        }

        const activeUsers = this.users.filter(user => user.active && UserType.DEFAULT)

        return activeUsers.length < this.$currentCompany.amountOfUsers
    }

    get sortedUsers(): User[] {
        let users = this.users

        if (this.showInactiveUsers === false) {
            users = users.filter((user: User) => user.active === true)
        }

        return users
            .filter((user: User) => user.type === UserType.DEFAULT)
            .sort((a: User, b: User) => a.name.localeCompare(b.name)) as User[]
    }

    get companyManagers(): User[] {
        return this.sortedUsers.filter(user => {
            return user.role === Role.COMPANY_MANAGER
        })
    }

    get branchManagers(): User[] {
        return this.sortedUsers.filter(user => {
            return user.role === Role.BRANCH_MANAGER
        })
    }

    get teamLeads(): User[] {
        return this.sortedUsers.filter(user => {
            return user.role === Role.TEAM_LEAD
        })
    }

    get employees(): User[] {
        return this.sortedUsers.filter(user => {
            return user.role === Role.EMPLOYEE
        })
    }
}
